import { useEffect, useRef } from 'react';
import { registerNavigationGuard } from '../../core/clientDestination';
import { useTranslation } from './useTranslation';
/** Shared protection for draft editors. Return the same check for local Close. */
export function useUnsavedChanges(dirty: boolean, busy = false) {
  const t = useTranslation();
  const state = useRef({ dirty, busy }); state.current = { dirty, busy };
  const leave = () => {
    if (state.current.busy) return false;
    if (state.current.dirty && !window.confirm(t('cohesion.unsaved'))) return false;
    state.current.dirty = false; return true;
  };
  useEffect(() => {
    const remove = registerNavigationGuard(leave);
    const unload = (event: BeforeUnloadEvent) => { if (state.current.dirty || state.current.busy) { event.preventDefault(); event.returnValue = ''; } };
    window.addEventListener('beforeunload', unload);
    return () => { remove(); window.removeEventListener('beforeunload', unload); };
  }, [t]);
  return leave;
}
